import React, {useState } from 'react';
import { FaCopy } from "react-icons/fa";
import { FiFacebook, FiTwitter, FiLinkedin } from 'react-icons/fi';
import { HiOutlineMail } from "react-icons/hi";
import CopyToClipboard from 'react-copy-to-clipboard';
import moment from 'moment-timezone'
// import CryptoJS from "crypto-js";
import { secretPass } from '../env';

export const formatPhoneNumber = (phoneNumberString)  => {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

export const ShareProfilePropup = ({ ProfileKey, shareLinkUrl }) => {
  const [copied, setCopied] = useState(false);
  return (
    <div
      className="modal fade"
      id="personalInviteModal"
      tabIndex="-1"
      aria-labelledby="personalInviteModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title">Your Personal Invite Link</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pt-0">
            <p>
              For every successful signup, you will get 20 additional credits.
            </p>
            <div className="input-group copyinputcontainer mb-3">
              <input
                type="text"
                readOnly={true}
                className="form-control"
                defaultValue={`${window.location.origin}/register?invite=${ProfileKey}`}
              />
              <div className="input-group-prepend">
                {copied && <span className="tooltip-text">Copied!</span>}
                <CopyToClipboard
                  text={`${window.location.origin}/register?invite=${ProfileKey}`}
                  onCopy={() => {
                    setCopied(true);
                    setTimeout(() => {
                      setCopied(false);
                    }, 500);
                  }}
                >
                  <div
                    className="input-group-text btn px-3 btn-primary text-white"
                    id="btnGroupAddon"
                  >
                    <FaCopy size="1.5em" />
                  </div>
                </CopyToClipboard>
              </div>
            </div>

            <div className="buttonsGroup">
              <a
                href={`mailto:susan@3for3networking.com?subject=Invite%20Link&body=You%20are%20invited%20to%20a%20join%20with%20me%20${shareLinkUrl}`}
                className="btn btn-outline-primary rounded-10"
                target="_blank"
                rel="noreferrer"
              >
                <HiOutlineMail /> Email
              </a>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${shareLinkUrl}`}
                rel="noreferrer"
                target="_blank"
                className="btn btn-outline-primary rounded-10"
              >
                <FiFacebook /> Facebook
              </a>
              <a
                href={`https://www.linkedin.com/shareArticle?url=${shareLinkUrl}&title=3For3%20Networking`}
                rel="noreferrer"
                target="_blank"
                className="btn btn-outline-primary rounded-10"
              >
                <FiLinkedin /> Linkedin
              </a>
              <a
                href={`https://twitter.com/intent/tweet?text=${shareLinkUrl}`}
                rel="noreferrer"
                target="_blank"
                className="btn btn-outline-primary rounded-10"
              >
                <FiTwitter /> Twitter
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// export const checkDateIsPast = (meetingDate, timeZone) => {
//   console.log("meetingDate ", meetingDate);
//   console.log({timeZone});

//   // Given UTC date string (from DB)
//   const utcDateStr = meetingDate;

//   // Parse it explicitly as UTC
//   const utcMoment = moment.utc(utcDateStr, "YYYY-MM-DD HH:mm:ss");

//   // User-selected timezone from settings
//   const userTimezone = timeZone; // Replace this with the actual setting

//   // Convert UTC to user's timezone
//   const userTime = utcMoment.clone().tz(userTimezone);

//   // Get current time in user's timezone
//   const now = moment().tz(userTimezone);

//   // Check if the meeting is in the future (not passed yet)
//   const isUpcoming = userTime.isAfter(now);

//   // console.log("User Local Meeting Time:", userTime.format());
//   // console.log("Now in User Timezone:", now.format());
//   // console.log("Is Meeting Upcoming?", isUpcoming);

//   return !isUpcoming;

//   // return moment(moment().unix()).isAfter(moment(meetingDate).unix()) // OLD Code
// }

export const checkDateIsPast = (meetingDate, timeZone, utcMeetingDate = null) => {
  const utcMoment = utcMeetingDate
    ? moment(utcMeetingDate, "YYYY-MM-DD HH:mm:ss")
    : moment.utc(meetingDate, "YYYY-MM-DD HH:mm:ss");
  console.log(
    moment.utc(meetingDate, "YYYY-MM-DD HH:mm:ss")
      .format("YYYY-MM-DD HH:mm:ss A")
  );
  console.log(moment(utcMoment).format("YYYY-MM-DD HH:mm:ss"));
  // const utcMoment = moment(meetingDate, "YYYY-MM-DD HH:mm:ss");
  const userTime = utcMoment.clone().tz(timeZone);
  const now = moment().tz(timeZone);
  console.log(moment(userTime).format("YYYY-MM-DD HH:mm:ss a"));
  console.log(moment(now).format("YYYY-MM-DD HH:mm:ss a"));
  return userTime.isBefore(now);
};


export const generateTimeOptions = (minuteIncrement = 15) => {
  const timeOptions = [];

  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += minuteIncrement) {
      // const formattedHour = (hour % 12 || 12).toString().padStart(2, "0");
      const formattedHour = (hour % 12 || 12).toString();
      const formattedMinute = minute.toString().padStart(2, "0");
      const ampm = hour < 12 ? "AM" : "PM";
      const time_12_hours = `${formattedHour}:${formattedMinute} ${ampm}`;
      const time_24_hours = `${hour}:${formattedMinute}`;
      // const isDisabled =
      //   hour < currentHour ||
      //   (hour === currentHour && minute < currentMinute + 15);
      timeOptions.push(
        <option key={time_12_hours} value={time_24_hours} disabled={false}>
          {time_12_hours}
        </option>
      );
    }
  }

  return timeOptions;
}; 

export const generateEncryptKey = (key) => {
  // return CryptoJS.AES.encrypt(key, secretPass).toString()
}

// Utility: Encode/Decode Base64
const base64Encode = (arr) => btoa(String.fromCharCode(...new Uint8Array(arr)));
const base64Decode = (str) => Uint8Array.from(atob(str), c => c.charCodeAt(0));

// TextEncoder/Decoder
const encoder = new TextEncoder();
const decoder = new TextDecoder();

async function getKeyFromPassword(password = secretPass, salt) {
  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    encoder.encode(password),
    { name: "PBKDF2" },
    false,
    ["deriveKey"]
  );

  return await crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: salt,
      iterations: 100000,
      hash: "SHA-256",
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"]
  );
}

export async function encryptEmail(email, password = secretPass) {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const key = await getKeyFromPassword(password, salt);

  const encrypted = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    key,
    encoder.encode(email)
  );

  return {
    cipherText: base64Encode(encrypted),
    iv: base64Encode(iv),
    salt: base64Encode(salt),
  };
}

export async function decryptEmail(encryptedData, password = secretPass) {
  const iv = base64Decode(encryptedData.iv);
  const salt = base64Decode(encryptedData.salt);
  const cipherText = base64Decode(encryptedData.cipherText);

  const key = await getKeyFromPassword(password, salt);

  try {
    const decrypted = await crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv,
      },
      key,
      cipherText
    );

    return decoder.decode(decrypted);
  } catch (e) {
    throw new Error("Decryption failed. Invalid password or corrupted data.");
  }
}
